<template>
  <div class="grid-container">
    <div
      id="how-it-works-container"
      class="lh-element-topborder padding-top-m margin-bottom-m"
    >
      <div class="grid-x padding-bottom-l">
        <h3>
          {{ TITLE }}
        </h3>
      </div>
      <HowItWorksDetail />
    </div>
  </div>
</template>
<script setup>
import { HOW_IT_WORKS } from '../../config';
import HowItWorksDetail from './HowItWorksDetail';

const { TITLE } = HOW_IT_WORKS;
</script>
